import { render, staticRenderFns } from "./Searchbar.vue?vue&type=template&id=46744e88"
import script from "./Searchbar.vue?vue&type=script&lang=js"
export * from "./Searchbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports